(() => {
  if (customElements.get('oct-events-controller')) return;
  class OctEventsController extends HTMLElement {}
  customElements.define('oct-events-controller', OctEventsController);
  const controllers = new Map();
  function initialize(root) {
    if (controllers.has(root)) return;
    const abort = new AbortController();
    const options = { signal: abort.signal };
    const track = root.querySelector('[data-oe-track]');
    const cards = Array.from(root.querySelectorAll('[data-oe-card]'));
    const filters = root.querySelector('[data-oe-filters]');
    const dialog = root.querySelector('[data-oe-dialog]');
    const host = root.querySelector('[data-oe-widget]');
    let category = '', trigger;
    let fallbackTimer;
    const limit = Number(root.dataset.limit) || 8;
    let dateFormat, badgeFormat;
    try {
      const locale = root.dataset.locale || 'en-GB';
      const timeZone = root.dataset.timezone || 'Europe/London';
      dateFormat = new Intl.DateTimeFormat(locale, { timeZone, day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      badgeFormat = new Intl.DateTimeFormat(locale, { timeZone, weekday: 'short', day: '2-digit', month: 'short' });
    } catch {
      dateFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', dateStyle: 'medium', timeStyle: 'short' });
      badgeFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', weekday: 'short', day: '2-digit', month: 'short' });
    }
    cards.forEach(card => {
      const start = new Date(Number(card.dataset.start) * 1000);
      const end = new Date(Number(card.dataset.end) * 1000);
      const time = card.querySelector('[data-oe-time]');
      if (time) time.textContent = dateFormat.format(start) + (time.dataset.hasEnd === 'true' ? ' – ' + dateFormat.format(end) : '');
      badgeFormat.formatToParts(start).forEach(part => {
        const node = card.querySelector('[data-oe-' + part.type + ']');
        if (node) node.textContent = part.value;
      });
    });
    const ordered = cards.sort((a, b) => {
      if (root.dataset.order === 'featured') {
        const difference = Number(b.dataset.featured === 'true') - Number(a.dataset.featured === 'true');
        if (difference) return difference;
      }
      return Number(a.dataset.start) - Number(b.dataset.start);
    });
    ordered.forEach(card => track.append(card));
    function refresh() {
      const now = Date.now() / 1000;
      const live = ordered.filter(card => Number(card.dataset.end) > now);
      const matches = live.filter(card => !category || card.dataset.category === category);
      ordered.forEach(card => { card.hidden = !matches.slice(0, limit).includes(card); });
      root.querySelector('[data-oe-empty]').hidden = live.length > 0;
      root.querySelector('[data-oe-filter-empty]').hidden = !live.length || matches.length > 0;
      track.hidden = matches.length === 0;
      if (filters) filters.hidden = !live.length;
    }
    if (filters) {
      Array.from(new Set(cards.map(card => card.dataset.category).filter(Boolean))).sort().forEach(value => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'oe-filter'; button.dataset.category = value;
        button.textContent = value; button.setAttribute('aria-pressed', 'false'); filters.append(button);
      });
      filters.addEventListener('click', event => {
        const button = event.target.closest('[data-category]');
        if (!button) return;
        category = button.dataset.category;
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        refresh(); track.scrollLeft = 0;
      }, options);
    }
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-oe-book]');
      if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      const id = link.dataset.widget.trim();
      if (!/^[a-f0-9-]{36}$/i.test(id) || typeof dialog.showModal !== 'function') return;
      let fallback;
      try { fallback = new URL(link.href); if (!['https:', 'http:'].includes(fallback.protocol)) return; } catch { return; }
      try {
        host.replaceChildren();
        trigger = link;
        root.querySelector('[data-oe-dialog-title]').textContent = link.dataset.title;
        root.querySelector('[data-oe-fallback]').href = fallback.href;
        dialog.showModal();
        document.documentElement.classList.add('oe-booking-open');
        const frame = document.createElement('iframe');
        frame.title = link.dataset.title;
        frame.allow = 'payment';
        frame.style.height = '650px';
        frame.srcdoc = '<!doctype html><html><head><meta name="viewport" content="width=device-width, initial-scale=1"><style>html,body{margin:0;background:#fffdf4}iframe{max-width:100%!important}body{display:flex;justify-content:center}</style></head><body><script src="https://assets.ticketinghub.com/checkout.js" data-widget="' + id + '" data-layout="embed" data-width="100%" data-no-minify="1"><' + '/script></body></html>';
        host.append(frame);
        event.preventDefault();
        fallbackTimer = window.setTimeout(() => {
          const visibleFrame = host.querySelector('iframe');
          if (!visibleFrame?.contentDocument?.querySelector('iframe')) { dialog.close(); window.location.assign(fallback.href); }
        }, 12000);
      } catch {
        host.replaceChildren(); dialog.close(); document.documentElement.classList.remove('oe-booking-open');
      }
    }, options);
    root.querySelector('[data-oe-close]').addEventListener('click', () => dialog.close(), options);
    dialog.addEventListener('close', () => {
      clearTimeout(fallbackTimer); host.replaceChildren();
      document.documentElement.classList.remove('oe-booking-open'); trigger?.focus();
    }, options);
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
    }, options);
    refresh();
    const timer = setInterval(refresh, 30000);
    controllers.set(root, () => { clearInterval(timer); clearTimeout(fallbackTimer); if (dialog.open) dialog.close(); host.replaceChildren(); abort.abort(); controllers.delete(root); });
  }
  function scan(container) { container.querySelectorAll('[data-oe-events]').forEach(initialize); }
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-oe-events]').forEach(root => controllers.get(root)?.());
  });
})();
